/**
 * This class is used for transforming translations data.
 */
export default class TranslationsTransformer {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.translationPrefixApplication Translation prefix application.
     */
    constructor(options) {
        this.translationPrefixApplication = options?.translationPrefixApplication || null;
    }
    /**
     * Transforms data into a ITranslations model.
     *
     * @param data Response data to parse.
     * @returns Localized information model.
     */
    transform(data) {
        return this.replaceApplicationPrefixInKeys(data);
    }
    /**
     * Recursively replaces application prefix in all keys in the object.
     *
     * @param objectOrString Object or string.
     */
    replaceApplicationPrefixInKeys(objectOrString) {
        if (!objectOrString || typeof objectOrString === 'string') {
            return objectOrString;
        }
        const objectWithUpdatedKeys = {};
        for (const key in objectOrString) {
            const updatedKey = this.replaceApplicationPrefixInKey(key);
            if (updatedKey) {
                objectWithUpdatedKeys[updatedKey] = this.replaceApplicationPrefixInKeys(objectOrString[key]);
            }
        }
        return objectWithUpdatedKeys;
    }
    /**
     * @param key The key to replace application prefix in.
     */
    replaceApplicationPrefixInKey(key) {
        const application = this.translationPrefixApplication;
        if (!application) {
            return key;
        }
        const pairs = key.split('__');
        if (pairs.length > 1 && pairs[0] === application) {
            return pairs[1];
        }
        // We should remove other application prefixed keys that don't match the application.
        if (pairs.length > 1) {
            return null;
        }
        return key;
    }
}
//# sourceMappingURL=TranslationsTransformer.js.map